export class UncriticalLink {
	static selector = 'link[data-uncritical-link]';

	static createFromNodeList (nodeList) {
		return Array
			.from(nodeList)
			.map(node => new this(node));
	}

	constructor (element) {
		this.loadCss = this.#loadCss.bind(this);
		this.element = element;

		this.init();
	}

	#loadCss () {
		this.unbindEvents();
		this.element.rel = 'stylesheet';
		window.dispatchEvent(new Event('resize'));
	}

	bindEvents () {
		window.addEventListener('scroll', this.loadCss, {once: true});
		window.addEventListener('mousemove', this.loadCss, {once: true});
	}

	unbindEvents () {
		window.removeEventListener('scroll', this.loadCss);
		window.removeEventListener('mousemove', this.loadCss);
	}

	init () {
		// Load immediately if scroll position is not at the top
		if (window.scrollY > 0) {
			this.loadCss();
			return;
		}

		// Bind events to detect user input
		this.bindEvents();
	}
};
